import { fetchAppConfig } from '../../common/configUtil';
import { handleApiError } from '../../common/util';
import { IDatabase } from '../../models/portal/database.model';
import axiosDmsInstance from '../dms/axiosDmsInstance';
import axiosPortalInstance from './axiosPortalInstance';

export const getDatabasesByCompanyNumber = async (companyNumber: string): Promise<IDatabase[]> => {
  try {
    const url = `/api/database/company/${companyNumber}/database`;
    const response = await axiosPortalInstance.get<IDatabase[]>(url, {
      params: {
        deploymentTypeCode: (await fetchAppConfig()).deploymentTypeCode || 'UNKNOWN_DEPLOYMENTTYPECODE',
        moduleCode: process.env.REACT_APP_MODULE_CODE,
      },
    });
    return response.data;
  } catch (err: any) {
    return handleApiError('getDatabasesByCompanyNumber', err);
  }
};

export const getDatabaseTimeOffsetMinutes = async () => {
  const url = `/api/utility/databaseinfo/v1/server/timeoffsetminutes`;
  const response = await axiosDmsInstance.get<number>(url);
  return response.data;
};
